import React, { Component } from 'react'
import { connect } from 'react-redux'
import './alimentationType.css'

class AlimentationType extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedOption: props.tipoalimentacion?.type || '',
      vegetarianOptions: {
        huevos: props.tipoalimentacion?.huevos || false,
        lacteos: props.tipoalimentacion?.lacteos || false,
      },
    }
  }

  componentDidMount() {
    this.setState({
      selectedOption: this.props.tipoalimentacion?.type || '',
      vegetarianOptions: {
        huevos: this.props.tipoalimentacion?.huevos || false,
        lacteos: this.props.tipoalimentacion?.lacteos || false,
      },
    })
  }
  handleSelect = (option) => {
    this.setState({ selectedOption: option }, () => {
      this.props.selectOtionAlimentation({
        type: option,
        ...this.state.vegetarianOptions,
      })
    })
  }

  handleSubOptionChange = (e) => {
    const { name, checked } = e.target
    this.setState(
      (prevState) => ({
        vegetarianOptions: {
          ...prevState.vegetarianOptions,
          [name]: checked,
        },
      }),
      () => {
        this.props.selectOtionAlimentation({
          type: this.state.selectedOption,
          ...this.state.vegetarianOptions,
        })
      }
    )
  }

  render() {
    const { selectedOption, vegetarianOptions } = this.state
    const options = [
      {
        value: 'omnivora',
        title: 'Omnívora 🥦🥩',
        desc: 'Comes de todo: carne, pescado, huevos, lácteos, frutas, verduras, cereales, legumbres.',
      },
      {
        value: 'pescetariana',
        title: 'Pescetariana 🐟🥦',
        desc: 'No comes carne, pero sí pescado, mariscos, huevos, lácteos, frutas, verduras, cereales y legumbres.',
      },
      {
        value: 'vegetariana',
        title: 'Vegetariana 🥦',
        desc: 'No comes carne ni pescado, pero sí huevos y/o lácteos.',
      },
      {
        value: 'vegana',
        title: 'Vegana 🌱',
        desc: 'Solo alimentos de origen vegetal (sin carne, pescado, huevos, lácteos ni miel).',
      },
    ]
    return (
      <div className="container alimentation-type">
        <div className="row">
          <div className="section-text__allergies col-md-12 col-lg-6">
            Tipo de alimentación
          </div>

          <div className="options col-md-12 col-lg-6">
            <p>
              Selecciona el tipo de alimentación que llevas y haz clic en
              <strong> siguiente</strong>
            </p>

            <div className="alimentacion-container">
              {options.map((option) => (
                <label
                  key={option.value}
                  className={`option-card ${
                    selectedOption === option.value ? 'selected' : ''
                  }`}
                  onClick={() => this.handleSelect(option.value)}
                >
                  <input
                    type="radio"
                    name="alimentacion"
                    value={option.value}
                    checked={selectedOption === option.value}
                    onChange={() => this.handleSelect(option.value)}
                  />
                  <div className="option-title">{option.title}</div>
                  <div className="option-desc">{option.desc}</div>

                  {option.value === 'vegetariana' &&
                    selectedOption === 'vegetariana' && (
                      <div className="suboptions">
                        <p>Deshabilita los alimentos que no consumas</p>
                        <div className="suboption-group">
                          <label
                            className={
                              !vegetarianOptions.huevos ? 'inactive' : ''
                            }
                          >
                            <input
                              type="checkbox"
                              name="huevos"
                              checked={vegetarianOptions.huevos}
                              onChange={this.handleSubOptionChange}
                            />
                            Huevos
                          </label>
                          <label
                            className={
                              !vegetarianOptions.lacteos ? 'inactive' : ''
                            }
                          >
                            <input
                              type="checkbox"
                              name="lacteos"
                              checked={vegetarianOptions.lacteos}
                              onChange={this.handleSubOptionChange}
                            />
                            Lácteos
                          </label>
                        </div>
                      </div>
                    )}
                </label>
              ))}
            </div>
            <p>
              En caso de una dieta omnívora o pescetariana, usted más adelante
              va a poder elegir los tipos de carne que consume y también podrá
              decirnos sus alergias e intolerancias.
            </p>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  tipoalimentacion: state.tipoalimentacion,
})

const mapDispatchToProps = (dispatch) => ({
  selectOtionAlimentation(option) {
    dispatch({
      type: 'SELECT_TIPOALIMENTACION',
      tipoalimentacion: option,
    })
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(AlimentationType)
